// extracted by mini-css-extract-plugin
export default {"instructions":"AndroidQrModal_instructions__tkY64","qrWrapper":"AndroidQrModal_qrWrapper__JApCf"};